import PropTypes from "prop-types";
// material-ui
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

// project-imports
import DrawerHeaderStyled from "./DrawerHeaderStyled";

import Logo from "components/logo";
import { HEADER_HEIGHT } from "config";
import { V2 } from "../drawerV2Tokens";
import { X as CloseIcon } from "lucide-react";

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open, fullWidthMobile = false, onClose }) {
  const theme = useTheme();

  if (fullWidthMobile) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.75,
          minHeight: HEADER_HEIGHT,
          width: "100%",
          bgcolor: V2.surfaceSolid,
          borderBottom: `1px solid ${V2.line}`,
          fontFamily: V2.fontBody,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontFamily: V2.fontBody,
            color: V2.ink,
            fontSize: "1.05rem",
          }}
        >
          Menu
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="Fermer le menu"
          size="large"
          sx={{
            color: V2.ink,
            borderRadius: 0,
            border: `1px solid ${V2.line}`,
            width: 40,
            height: 40,
            "&:hover": {
              bgcolor: V2.accentSoft,
              borderColor: V2.accentBorder,
              color: V2.accent,
            },
          }}
        >
          <CloseIcon size={20} />
        </IconButton>
      </Box>
    );
  }

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        minHeight: open ? "auto" : HEADER_HEIGHT,
        width: "inherit",
        pt: open ? "20px" : 2.5,
        pb: open ? "20px" : 2.5,
        px: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Logo
        isIcon={!open}
        height={open ? 110 : undefined}
        maxWidth={open ? 170 : undefined}
        sx={{ width: open ? "auto" : 59, height: "auto" }}
      />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = {
  open: PropTypes.bool,
  fullWidthMobile: PropTypes.bool,
  onClose: PropTypes.func,
};
